import { render, staticRenderFns } from "./TextInputBuilder.vue?vue&type=template&id=399f48d8&scoped=true&"
import script from "./TextInputBuilder.vue?vue&type=script&lang=js&"
export * from "./TextInputBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TextInputBuilder.vue?vue&type=style&index=0&id=399f48d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f48d8",
  null
  
)

export default component.exports